export const DINHEIRO = 'Dinheiro';

export const MEIOS_PAGAMENTO = {
  dinheiro: '01',
  cheque: '02',
  credito: '03',
  debito: '04',
  credito_loja: '05',
  vale_alimentacao: '10',
  vale_refeicao: '11',
  vale_presente: '12',
  vale_combustivel: '13',
  boleto_bancario: '15',
  deposito_bancario: '16',
  pix: '17',
  transferencia: '18',
  cashback: '19',
  outros: '99',
  sem_pagamento: '90',
};

export default MEIOS_PAGAMENTO;
